// Shaders: authored in Slang at `src/shaders/<name>.slang`.
// The vite-plugin-slang compiles them to `src/shaders/generated/<name>.wgsl`
// (runs at dev-server startup and on file changes; also at `vite build`).
// We import the generated WGSL via Vite's built-in `?raw` query.

import backgroundWGSL from '../shaders/generated/background.wgsl?raw'
import creatureWGSL from '../shaders/generated/creature.wgsl?raw'
import playerWGSL from '../shaders/generated/player.wgsl?raw'
import chainWGSL from '../shaders/generated/chain.wgsl?raw'
import hazardWGSL from '../shaders/generated/hazard.wgsl?raw'
import floatiesWGSL from '../shaders/generated/floaties.wgsl?raw'
import eyesWGSL from '../shaders/generated/eyes.wgsl?raw'
import hyphaeWGSL from '../shaders/generated/hyphae.wgsl?raw'
import postprocessWGSL from '../shaders/generated/postprocess.wgsl?raw'
import hubRingWGSL from '../shaders/generated/hub-ring.wgsl?raw'
import landmarkWGSL from '../shaders/generated/landmark.wgsl?raw'
import particlesWGSL from '../shaders/generated/particles.wgsl?raw'
import wallsWGSL from '../shaders/generated/walls.wgsl?raw'

const shaders = {
  background: backgroundWGSL,
  creature: creatureWGSL,
  player: playerWGSL,
  chain: chainWGSL,
  hazard: hazardWGSL,
  floaties: floatiesWGSL,
  eyes: eyesWGSL,
  hyphae: hyphaeWGSL,
  postprocess: postprocessWGSL,
  'hub-ring': hubRingWGSL,
  landmark: landmarkWGSL,
  particles: particlesWGSL,
  walls: wallsWGSL,
} satisfies Record<string, string>

export type ShaderName = keyof typeof shaders

export function loadShader(name: ShaderName): string {
  return shaders[name]
}
